"use client";

import { useState } from "react";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { AnimatePresence, motion } from "framer-motion";
import { IoMenu, IoClose } from "react-icons/io5";
import logo from "@/public/images/logo.png";

export default function Navbar() {
  const router = useRouter();

  const [mobileMenuOpen, setMobileMenuOpen] =
    useState(false);

  const navigation = [

    {
      name: "Services",
      href: "/service",
    },
    {
      name: "Case Studies",
      href: "/case-studies",
    },
    {
      name: "Products",
      href: "/products",
    },
    {
      name: "Have Question?",
      href: "/contact",
    },
  ];

  return (
    <> <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100"> <nav className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8"> <div className="flex h-20 items-center justify-between">
      {/* Logo */}
      <div
        className="cursor-pointer"
        onClick={() => router.push("/")}
      > <Image
          src={logo}
          alt="ZySoftec"
          width={160}
          height={40}
          className="h-8 w-auto"
          priority
        /> </div>
      {/* Desktop Navigation */}
      <div className="hidden md:flex md:items-center md:space-x-10">
        {navigation.map((item) => (
          <a
            key={item.name}
            href={item.href}
            className="
                text-sm
                font-medium
                text-[#0F172A]
                hover:text-[#7A6FF0]
                transition-colors
              "
          >
            {item.name}
          </a>
        ))}
      </div>

      {/* Desktop CTA */}
      <div className="hidden md:flex">
        <button
          onClick={() =>
            router.push("/contact")
          }
          className="
              bg-[#000]
              hover:bg-[#695AE7]
              text-white
              text-sm
              font-medium
              px-5
              py-2.5
              rounded-lg
              transition-all
            "
        >
          Book Consultation
        </button>
      </div>

      {/* Mobile Menu Button */}
      <button
        onClick={() =>
          setMobileMenuOpen(
            !mobileMenuOpen
          )
        }
        className="md:hidden p-2"
      >
        {mobileMenuOpen ? (
          <IoClose size={24} />
        ) : (
          <IoMenu size={24} />
        )}
      </button>
    </div>
    </nav>
    </header>

      {/* Mobile Drawer */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <>
            <motion.div
              className="fixed inset-0 bg-black/40 z-40"
              initial={{
                opacity: 0,
              }}
              animate={{
                opacity: 1,
              }}
              exit={{
                opacity: 0,
              }}
              onClick={() =>
                setMobileMenuOpen(false)
              }
            />

            <motion.div
              className="
            fixed
            top-0
            right-0
            h-full
            w-80
            max-w-[85vw]
            bg-white
            z-50
            shadow-xl
            flex
            flex-col
          "
              initial={{
                x: "100%",
              }}
              animate={{
                x: 0,
              }}
              exit={{
                x: "100%",
              }}
              transition={{
                duration: 0.3,
              }}
            >
              <div className="flex items-center justify-between p-6 border-b">
                <h2 className="text-lg font-semibold">
                  Menu
                </h2>

                <button
                  onClick={() =>
                    setMobileMenuOpen(
                      false
                    )
                  }
                >
                  <IoClose size={24} />
                </button>
              </div>

              <div className="flex-1 p-6 space-y-2">
                {navigation.map((item) => (
                  <a
                    key={item.name}
                    href={item.href}
                    className="
                  block
                  py-3
                  text-base
                  font-medium
                  text-[#0F172A]
                  hover:text-[#7A6FF0]
                "
                    onClick={() =>
                      setMobileMenuOpen(
                        false
                      )
                    }
                  >
                    {item.name}
                  </a>
                ))}
              </div>

              <div className="p-6 border-t">
                <button
                  onClick={() => {
                    setMobileMenuOpen(
                      false
                    );

                    router.push(
                      "/contact"
                    );
                  }}
                  className="
                w-full
                bg-[#000]
                hover:bg-[#695AE7]
                text-white
                py-3
                rounded-lg
                font-medium
              "
                >
                  Book Consultation
                </button>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>


  );
}
